export const useAuthUser = () => useState('authUser', () => null)
